import type { ICourse, ILesson } from '@/Module/Lesson/Model/DataModel';

export const prepareLessonListFromCourse = (courseList: ICourse[]): ILesson[] => {
  return courseList.map(item => ({
    id: item.id,
    summery: item.summary,
    description: item.description,
    title: item.name,
    seoUrlSlug: item.seoUrlSlug,
    coverImageUrl: item.pictureUrl ?? '',
    seoTitle: item.seoTitle,
    seoDescription: item.seoDescription,
  }));
};
